import { render } from "./EditPhoneNumberDialog.vue?vue&type=template&id=dd8c3bb6&scoped=true"
import script from "./EditPhoneNumberDialog.vue?vue&type=script&lang=js"
export * from "./EditPhoneNumberDialog.vue?vue&type=script&lang=js"

import "./EditPhoneNumberDialog.vue?vue&type=style&index=0&id=dd8c3bb6&scoped=true&lang=css"
import "./EditPhoneNumberDialog.vue?vue&type=style&index=1&id=dd8c3bb6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8c3bb6"]])

export default __exports__